import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { observer } from 'mobx-react';
import { polarToCartesian } from '@jbrowse/core/util';
import { readConfObject } from '@jbrowse/core/configuration';
import { parseBreakend } from '@gmod/vcf';
function bpToRadians(block, pos) {
  var blockStart = block.region.elided ? 0 : block.region.start;
  var blockEnd = block.region.elided ? 0 : block.region.end;
  var bpOffset = block.flipped ? blockEnd - pos : pos - blockStart;
  return bpOffset / block.bpPerRadian + block.startRadians;
}
var Chord = observer(function Chord(_ref) {
  var feature = _ref.feature,
    blocksForRefs = _ref.blocksForRefs,
    radius = _ref.radius,
    config = _ref.config,
    bezierRadius = _ref.bezierRadius,
    selected = _ref.selected,
    _onClick = _ref.onClick;
  var _a, _b, _c, _d, _e;
  // find the blocks that our start and end points belong to
  var startBlock = blocksForRefs[feature.get('refName')];
  if (!startBlock) {
    return null;
  }
  var svType;
  if (feature.get('INFO')) {
    ;
    var _ref2 = feature.get('INFO').SVTYPE || [];
    var _ref3 = _slicedToArray(_ref2, 1);
    svType = _ref3[0];
  } else if (feature.get('mate')) {
    svType = 'mate';
  }
  var endPosition;
  var endBlock;
  var alt = (_a = feature.get('ALT')) === null || _a === void 0 ? void 0 : _a[0];
  var bnd = alt && parseBreakend(alt);
  if (bnd) {
    // VCF BND
    var matePosition = bnd.MatePosition.split(':');
    endPosition = +matePosition[1];
    endBlock = blocksForRefs[matePosition[0]];
  } else if (alt === '<TRA>') {
    // VCF TRA
    var chr2 = (_c = (_b = feature.get('INFO')) === null || _b === void 0 ? void 0 : _b.CHR2) === null || _c === void 0 ? void 0 : _c[0];
    var end = (_e = (_d = feature.get('INFO')) === null || _d === void 0 ? void 0 : _d.END) === null || _e === void 0 ? void 0 : _e[0];
    endPosition = parseInt(end, 10);
    endBlock = blocksForRefs[chr2];
  } else if (svType === 'mate') {
    // generic simplefeatures arcs
    var mate = feature.get('mate');
    var _chr = mate.refName;
    endPosition = mate.start;
    endBlock = blocksForRefs[_chr];
  }
  if (endBlock) {
    var startPos = feature.get('start');
    var startRadians = bpToRadians(startBlock, startPos);
    var endRadians = bpToRadians(endBlock, endPosition);
    var startXY = polarToCartesian(radius, startRadians);
    var endXY = polarToCartesian(radius, endRadians);
    var controlXY = polarToCartesian(bezierRadius, (endRadians + startRadians) / 2);
    var strokeColor = selected ? readConfObject(config, 'strokeColorSelected', {
      feature: feature
    }) : readConfObject(config, 'strokeColor', {
      feature: feature
    });
    var hoverStrokeColor = readConfObject(config, 'strokeColorHover', {
      feature: feature
    });
    return React.createElement("path", {
      "data-testid": "chord-".concat(feature.id()),
      d: ['M'].concat(_toConsumableArray(startXY), ['Q'], _toConsumableArray(controlXY), _toConsumableArray(endXY)).join(' '),
      style: {
        stroke: strokeColor
      },
      onClick: function onClick(evt) {
        if (endBlock && startBlock) {
          _onClick(feature, startBlock.region, endBlock.region, evt);
        }
      },
      onMouseOver: function onMouseOver(evt) {
        if (!selected) {
          evt.currentTarget.style.stroke = hoverStrokeColor;
          evt.currentTarget.style.strokeWidth = '3px';
        }
      },
      onMouseOut: function onMouseOut(evt) {
        if (!selected) {
          evt.currentTarget.style.stroke = strokeColor;
          evt.currentTarget.style.strokeWidth = '1px';
        }
      }
    });
  }
  return null;
});
export default Chord;